import "@/search";
import { search } from "@/search";

import "@/components/search/sort_button";
import "@/components/search/search_actions";
import "@/components/search/search_field";
import "@/components/search/search_token";
import "@/components/search/filter_button";
import "@/components/search/dropdown_filter";
import "@/components/search/switch_filter";
import "@/components/search/tri_switch_filter";
import "@/components/search/filter_tabs";
import "@/components/search/standalone-dropdown-filter";
import "@/components/search/loading_bar";
import "@/components/search/search_option";

window.dodona.search = search;
